/*
 * @Description:
 * @Author: JiuYue
 * @Date: 2020-10-10 17:18:44
 * @Reference:
 */
const config = {
  vuexStorageKeys: [
    'sessionToken'
  ],
  plugins: [
    'tk',
    'device',
    'vuexStorage',
    'user',
    'index',
    'routerAuth'
  ],
  navTheme: 'dark', // 导航主题: dark 或 light
  layoutMode: 'sidemenu', // 布局类型：sidemenu 或 topmenu
  contentWidth: 'Fluid', // 内容布局类型，Fluid 或 Fixed
  fixedHeader: true, // 是否固定头部
  fixSidebar: true, // 是否固定左侧导航栏
  projectName: '老张说装修',
  apiUrl: 'https://cloud.zhang.mokekeji.com',
  appID: 'de4XuwYvDjOi75KgyGsntCPxMFypcjiD',
  restKey: 'BSiqgBOuxbSvFd6nSrWZ0pYC39MsPQNs',
  masterKey: 'A1GuJGRbNFLy7eH13D2ZKeECbQ0pO3I2',
  modelJSON: require('./assets/json/model'),
  iconJSON: require('./assets/json/icon')
}
export default config
